var _text, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 168.7834 543.8093)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fill: "#FFFF00",
    fontFamily: "'Verdana-Bold'",
    fontSize: 20
  }, "simpleicon.com"), /*#__PURE__*/React.createElement("tspan", {
    x: -159.59,
    y: 24,
    fill: "#FFFF00",
    fontFamily: "'Verdana'",
    fontSize: 20
  }, "Collection Of Flat Icon, Symbols And Glyph Icons"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#020201",
    d: "M112.066,319.819c21.252-14.114,44.849-21.851,67.67-29.382c3.279-1.078,6.554-2.137,9.813-3.239 l0.668-0.221c4.822-1.689,9.393-3.284,13.134-5.345c0.169-0.394,0.411-1.049,0.7-2.135c-18.788-27.428-31.554-69.82-31.554-106.136 c0-30.807,9.682-53.629,27.941-67.526c-7.894-3.991-17.416-5.527-27.663-5.527c-27.307,0-49.442,10.91-49.442,50.082 c0,26.007,9.755,57.906,24.296,76.43c-0.135,1.464-0.308,2.931-0.571,4.388c-0.867,3.979-2.261,8.437-5.981,10.646 c-4.174,2.478-8.81,4.051-13.372,5.649c-18.912,6.365-38.472,11.975-55.258,23.121c-8.727,5.745-14.639,15.713-17.9,25.506 c-3.359,10.163-4.733,24.371-4.526,32.371h51.575C104.868,324.5,108.354,322.258,112.066,319.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020201",
    d: "M457.457,296.129c-3.263-9.793-9.178-19.379-17.9-25.125c-16.79-11.145-36.352-16.946-55.262-23.307 c-4.563-1.598-9.197-3.267-13.366-5.746c-3.726-2.213-5.121-6.715-5.982-10.698c-0.382-2.108-0.619-4.25-0.736-6.378 c13.712-18.761,22.809-49.369,22.809-74.471c0-39.18-22.137-50.097-49.443-50.097c-10.385,0-20.009,1.594-27.967,5.706 c18.105,13.913,27.697,36.684,27.697,67.366c0,35.358-11.861,76.072-29.895,103.673c0.049,0.313,0.097,0.619,0.153,0.925 c0.475,2.141,0.864,3.259,1.106,3.814c3.955,2.205,8.687,3.935,13.973,5.794l7.919,2.639c23.412,7.773,47.621,15.722,69.428,30.19 c3.524,2.325,6.852,4.085,9.971,8.085h52.019C462.189,320.5,460.813,306.292,457.457,296.129z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M414.744,368.006c-4.354-13.059-12.239-25.999-23.867-33.668c-22.386-14.854-48.47-22.674-73.685-31.155 c-6.084-2.133-12.264-4.395-17.82-7.701c-4.969-2.953-6.827-8.97-7.979-14.28c-0.507-2.816-0.824-5.678-0.981-8.519 c18.282-25.013,30.413-65.829,30.413-99.3c0-52.24-29.516-66.796-65.926-66.796c-36.408,0-65.922,14.541-65.922,66.776 c0,34.67,13.006,77.204,32.395,101.912c-0.181,1.947-0.41,3.902-0.76,5.842c-1.159,5.303-3.018,11.249-7.975,14.194 c-5.568,3.308-11.749,5.399-17.832,7.532c-25.215,8.489-51.297,15.965-73.677,30.827c-11.636,7.661-19.52,21.277-23.867,34.336 c-4.48,13.551-6.311,30.494-6.035,43.494h164.772h164.773C421.053,398.5,419.219,381.556,414.744,368.006z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.59dfcaab1f9289717ce0632a2f891263.svg";
export { ForwardRef as ReactComponent };